import { IconButton } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'
import ChevronLeftIcon from 'asterX-UI/Icons/ChevronLeftIcon'
import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import CommentsTab from 'components/Desktop/WorkListView/CommentsTab'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px'
  }
}))
const UserComments = ({ onClose }) => {
  const classes = useStyles()
  const {
    store: { comments },
    funcs: { addComments, getAllComments }
  } = useSelectionStore()
  const tabsList = [
    {
      label: 'Все',
      value: 'COMMENTS'
    },
    {
      label: 'Результаты задачи',
      value: '@result'
    },
    {
      label: 'Причина упущенных',
      value: 'MISSING'
    },
    {
      label: 'Фин сервис',
      value: 'FINSERVICE'
    }
  ]
  useEffect(() => {
    getAllComments()
  }, [])
  return (
    <PageContainerDesktop
      disablePaddings
      customHeader={
        <div className={classes.header}>
          <IconButton
            style={{
              color: GRAY_COLORS[400]
            }}
            onClick={onClose}
            size={'medium'}
          >
            <ChevronLeftIcon />
          </IconButton>
          <div className={classes.heading}>Коментарии</div>
        </div>
      }
    >
      <CommentsTab
        tabsList={tabsList}
        comments={comments}
        onAddComment={addComments}
      />
    </PageContainerDesktop>
  )
}

export default UserComments
